import React, { ComponentProps } from 'react';
import { map } from 'lodash';

import { FormGroupSelect } from '@components/Base';
import { useFrontlineUsersFetch } from './hook';

const FrontlineUserFormGroupSelect = (props: ComponentProps<typeof FormGroupSelect>) => {
  const frontlineUsers = useFrontlineUsersFetch();

  return (
    <FormGroupSelect {...props}>
      <option></option>
      {map(frontlineUsers, ({ id, name }) => (
        <option key={id} value={id}>{name}</option>
      ))}
    </FormGroupSelect>
  );
}

export { FrontlineUserFormGroupSelect };
